import styled, { css, keyframes } from 'styled-components';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';

export const ChatSectionStyled = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;

  /* &.sources-active {
    @media (min-width: 992px) {
      padding: 0 290px 0 0;
    }
    @media (min-width: 1400px) {
      padding: 0 390px 0 0;
    }
    @media (min-width: 1600px) {
      padding: 0 490px 0 0;
    }
  } */
`;

const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

export const ChatPageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding: 12px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: var(--body-bg);

  .agent-avatar {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .agent-meta {
    flex: 1;
    min-width: 0;

    .name {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: var(--white);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .subtitle {
      margin: 2px 0 0;
      font-size: 12px;
      color: var(--text-color-50);
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;

    button {
      width: auto;
      max-width: none;
      gap: 6px;
      padding: 8px 14px;
      white-space: nowrap;
    }

    .spin {
      animation: kai-spin 1s linear infinite;
    }

    .select-skeleton {
      height: 34px;
      min-width: 180px;
      border-radius: 8px;
      border: 1px solid #262626;
      background: #1a1a1a;
      animation: ${pulse} 1.5s ease-in-out infinite;
    }
  }

  @keyframes kai-spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 767px) {
    flex-wrap: wrap;

    .actions {
      width: 100%;
      justify-content: flex-end;
    }
  }
`;

export const ChatEmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  min-height: 280px;

  .icon-wrap {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: rgba(3, 160, 141, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 16px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .icon-skeleton {
      width: 100%;
      height: 100%;
      background: #262626;
      animation: ${pulse} 1.5s ease-in-out infinite;
    }
  }

  h3 {
    margin: 0 0 8px;
    font-size: 20px;
    font-weight: 600;
    color: var(--white);
  }

  p {
    margin: 0;
    max-width: 420px;
    font-size: 14px;
    line-height: 20px;
    color: #808080;
  }
`;

export const ChatInputBar = styled.div`
  flex-shrink: 0;
  padding: 12px 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
`;

/** Reference-style composer: textarea + send button */
export const ChatComposer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  max-width: 768px;
  margin: 0 auto;

  .hint {
    pointer-events: none;
    position: absolute;
    left: 50%;
    top: -40px;
    z-index: 10;
    transform: translateX(-50%);
    white-space: nowrap;
    border-radius: 8px;
    border: 1px solid #333;
    background: #1a1a1a;
    padding: 6px 12px;
    font-size: 12px;
    color: #c8c8c8;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);

    span {
      color: var(--primary);
      font-weight: 600;
    }
  }

  textarea {
    flex: 1;
    min-height: 44px;
    max-height: 128px;
    resize: none;
    background: #1a1a1a;
    border: 1px solid #262626;
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 14px;
    line-height: 20px;
    color: var(--white);
    outline: none;
    font-family: inherit;

    &::placeholder {
      color: #606060;
    }

    ${({ $hasSession }) =>
      $hasSession
        ? css`
            &:focus {
              border-color: rgba(3, 160, 141, 0.45);
            }
          `
        : css`
            opacity: 0.5;
            cursor: not-allowed;

            &:focus {
              border-color: #262626;
            }
          `}
  }

  button {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 12px;
    background: var(--primary);
    color: var(--white);
    cursor: pointer;
    transition: opacity 0.15s ease;

    &:hover:not(:disabled) {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
`;

export const ChatColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  min-width: 0;
  position: relative;
  padding: 0;

  &.kai-chat-layout {
    height: 100%;
  }

  .kai-chat-messages {
    flex: 1;
    min-height: 0;
    min-width: 0;
    height: auto !important;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 24px;
  }

  .kai-chat-empty {
    height: 100%;
    min-height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .kai-chat-thread {
    max-width: 48rem;
    margin: 0 auto;
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }

  .kai-chat-input {
    flex-shrink: 0;
    padding: 16px 24px;
    border-top: 1px solid #262626;
    background: var(--body-bg, #101010);

    .kai-chat-search {
      max-width: 48rem;
      margin: 0 auto;
    }
  }

  .kai-chat-print-header {
    display: none;
  }

  .error-text {
    color: var(--danger);
  }

  .chat-loader-text {
    display: block;
    font-weight: 400;
    margin-bottom: 10px;
    animation: ${pulse} 1.5s ease-in-out infinite;
  }

  .text-block {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 16px 20px;

    &.kai-chat-messages {
      display: flex;
      flex-direction: column;
      padding: 24px;
    }

    .user-text {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 8px;
      position: relative;
      padding-right: 0;
      padding-top: 4px;
      margin-bottom: 24px;

      .icon-box {
        display: none;
      }

      .title {
        max-width: 80%;
        margin: 0;
        padding: 12px 16px;
        border-radius: 16px 16px 4px 16px;
        background: var(--primary);
        color: #000;
        font-weight: 400;
        font-size: 14px;
        line-height: 1.5;
        white-space: pre-line;
      }

      .see-source-button {
        position: static;
        flex-shrink: 0;
        margin: 0;
        padding: 5px 10px;
        color: #a0a0a0;
        background: #161616;
        border: 1px solid #262626;
        border-radius: 8px;
        font-size: 12px;
        line-height: 1.2;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          color: #fff;
          border-color: #333;
        }
      }
    }

    .heading {
      margin: 0 0 24px;
      position: relative;
      padding-left: 0;
      line-height: 28px;
      max-width: 100%;
      min-width: 0;
      overflow-x: hidden;

      &:not(.user-text) {
        .icon-box {
          display: none;
        }

        .ai-message-content,
        .streaming-text {
          max-width: 100%;
          width: 100%;
          min-width: 0;
          box-sizing: border-box;
          padding: 12px 16px;
          border-radius: 16px 16px 16px 4px;
          background: #1a1a1a;
          border: 1px solid #262626;
          color: #e0e0e0;
          font-size: 14px;
          line-height: 1.5;
          overflow-x: hidden;
          overflow-wrap: anywhere;
          word-break: break-word;

          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            color: #fff;
          }

          p,
          li,
          span {
            color: #e0e0e0;
          }

          strong,
          b {
            color: #fff;
          }

          em {
            color: #d4d4d4;
          }

          th {
            color: #fff;
          }

          td {
            color: #c8c8c8;
          }

          blockquote {
            color: #a8a8a8;
          }

          code {
            color: var(--primary);
          }

          pre code {
            color: #f8f8f2;
          }

          hr {
            border-color: #333;
          }
        }
      }

      .ai-message-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        overflow-x: hidden;
      }

      .streaming-text {
        white-space: pre-wrap;
        word-break: break-word;
        line-height: 1.6;
        color: #e0e0e0;
      }

      a {
        text-decoration: underline;
        color: var(--primary-50);
      }

      .icon-box {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        font-size: 20px;
        line-height: 23px;
        font-weight: 700;
        text-transform: uppercase;
        border-radius: 50px;
        color: var(--white);
        background: #03a08d;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &--purple {
          background: rgb(135 137 147 / 48%);
        }
      }

      .chat-table-wrap {
        display: block;
        width: 100%;
        max-width: 100%;
        margin: 12px 0;
        overflow-x: auto;
        overflow-y: hidden;
        overscroll-behavior-x: contain;
        border-radius: 8px;
        border: 1px solid #2a2a2a;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          height: 8px;
        }
        &::-webkit-scrollbar-track {
          background: #161616;
        }
        &::-webkit-scrollbar-thumb {
          background: #3a3a3a;
          border-radius: 4px;
        }
      }

      table {
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
      }

      .chat-table-wrap > table {
        width: 100%;
        min-width: 100%;
        table-layout: fixed;
      }

      th,
      td {
        border: 1px solid rgba(157, 157, 157, 0.3);
        border-spacing: 0;
        padding: 10px 12px;
        text-align: left;
        vertical-align: top;
        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
        min-width: 0;
      }

      th {
        font-weight: 600;
        background: #222;
      }

      .lucide-download {
        display: none;
      }

      .title {
        display: block;
        margin: 0;
      }

      pre {
        max-width: 100%;
        overflow-x: auto;
        background-color: #1e1e1e;
        color: #f8f8f2;
        padding: 16px;
        border-radius: 8px;
        font-family: 'Fira Code', 'Source Code Pro', monospace;
        font-size: 16px;
        line-height: 26px;
        margin-top: 10px;
        margin-bottom: 10px;
        border: 1px solid #333;

        &::-webkit-scrollbar {
          height: 8px;
        }
        &::-webkit-scrollbar-thumb {
          background: #555;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background: #777;
        }
      }
    }

    .title {
      display: block;
      font-size: 20px;
      line-height: 24px;
      font-weight: 700;
      margin: 0 0 20px;
    }

    .text-box {
      width: 100%;
      margin: 0 0 20px;
    }

    .detail-box {
      width: 100%;
      padding: 20px 0;
      border-top: 1px solid #cdcdcd;

      .list {
        margin: 0;
        padding: 0 0 0 15px;

        li {
          margin: 0 0 15px;
        }
      }
    }

    .reponse-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      .agent-name {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        color: var(--text-color);
        padding: 8px 15px;
        border-radius: 10px;
        background: var(--white);
      }

      .action-list {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;

        li {
          margin: 0;
        }

        button {
          font-size: 22px;
          line-height: 1;
          color: var(--light-gray);

          &:hover {
            color: var(--text-color);
          }
        }
      }
    }
  }

  .swiper-holder {
    position: relative;

    .swiper {
      padding-top: 20px;
      margin-bottom: 20px;
      overflow: hidden;
      /* .swiper-wrapper {
      display: flex;
      gap: 12px;
      overflow: hidden;
    } */
      .swiper-slide {
        /* cursor: pointer;
      margin: 0 !important; */

        .img-wrap {
          display: block;
          width: 200px !important;
          height: 150px;
          overflow: hidden;
          border-radius: 10px;
          border: 1px solid #cdcdcd;

          @media (min-width: 768px) {
            width: 300px !important;
            height: 200px;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    .swiper-controls {
      display: flex;
      gap: 10px;
    }

    .swiper-controls button {
      position: absolute;
      top: 50%;
      right: 10px;
      left: auto;
      width: 30px;
      height: 30px;
      background: #f1f1f9;
      color: var(--black);
      border-radius: 50%;
      border: none;
      cursor: pointer;

      &::after {
        display: none;
      }
      svg {
        width: 20px;
      }
    }

    .swiper-button-prev {
      right: auto !important;
      left: 10px !important;
    }
  }

  @media print {
    &.kai-chat-layout {
      display: block;
      width: 100%;
      height: auto;
      min-height: 0;
      overflow: visible;
      padding: 14mm 12mm;
      background: #fff;
      color: #111;
      font-size: 10.5pt;
    }

    .kai-chat-screen-header,
    .kai-chat-input,
    .see-source-button,
    .swiper-controls,
    .icon-box,
    .chat-steps-panel.is-collapsed {
      display: none !important;
    }

    * {
      animation: none !important;
      transition: none !important;
    }

    .kai-chat-print-header {
      display: block;
      width: 100%;
      max-width: none;
      margin: 0 0 20px;
      padding: 0 0 12px;
      border-bottom: 1px solid #d0d5dd;

      h1 {
        margin: 0 0 8px;
        color: #111;
        font-size: 19pt;
        line-height: 1.25;
      }

      .kai-chat-print-meta {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 2px 12px;
        margin: 0;

        dt {
          margin: 0;
          color: #667085;
          font-size: 8pt;
          font-weight: 700;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }

        dd {
          margin: 0;
          color: #344054;
          font-size: 9pt;
          overflow-wrap: anywhere;
        }
      }
    }

    .kai-chat-messages,
    .text-block {
      display: block;
      width: 100%;
      height: auto !important;
      min-height: 0;
      overflow: visible !important;
      padding: 0;
    }

    .kai-chat-thread {
      width: 100%;
      max-width: none;
      margin: 0;
      overflow: visible;
    }

    .text-block .user-text {
      align-items: flex-end;
      gap: 4px;
      margin: 0 0 14px;
      padding: 0;
    }

    .text-block .user-text .title {
      max-width: 85%;
      padding: 8px 12px;
      border: 1px solid #d8dde5;
      border-radius: 8px;
      background: #eef1f5 !important;
      color: #111 !important;
      font-size: 10.5pt;
      font-weight: 600;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    .text-block .heading:not(.user-text) {
      margin: 0 0 20px;
      padding: 0;
      overflow: visible;
    }

    .text-block .heading:not(.user-text) .ai-message-content {
      width: 100%;
      max-width: 100%;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: #1f1f1f !important;
      font-size: 10.5pt;
      line-height: 1.55;
      overflow: visible;
    }
  }
`;

export const SearchResultCol = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  flex-shrink: 0;
  width: 300px;
  padding: 10px 20px;
  border-left: 1px solid rgba(157, 157, 157, 0.3);
  background: #19191b;
  z-index: 999;

  @media (min-width: 1200px) {
    width: 500px;
  }
  .content-box {
    box-shadow: rgba(255, 255, 255, 0.05) 0px 0px 0px 1px;
    padding: 8px 16px;
    border-radius: 6px;
    margin-bottom: 10px;
    transition: 0.3s all ease-in-out;
    &:hover {
      box-shadow:
        rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
        rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    }
  }

  .tablist {
    list-style: none;
    margin: 0 0 20px;
    padding: 0;
    display: flex;
    gap: 15px;
    position: relative;
    padding-right: 35px;

    @media (min-width: 1400px) {
      gap: 30px;
    }
    .source-close {
      width: 20px;
      height: 20px;
      border: 1px solid var(--danger);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      position: absolute;
      right: 5px;
      top: 5px;
    }
    li {
      margin: 0;

      button {
        display: block;
        font-size: 16px;
        line-height: 20px;
        text-transform: capitalize;
        padding: 0 0 5px;
        color: var(--white);
        border-bottom: 2px solid transparent;

        @media (min-width: 1400px) {
          font-size: 18px;
          line-height: 22px;
        }

        &.active {
          font-weight: 700;
          border-bottom: 2px solid var(--white);
        }
      }
    }
  }

  .tab-content {
    position: relative;

    .imgs-wrap,
    .video-wrap {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 15px;
    }
  }

  .content-box {
    position: relative;
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;

    .head {
      margin: 0 0 10px;
      display: flex;
      align-items: center;
      gap: 10px;

      .img-box {
        width: 22px;
        flex-shrink: 0;
      }

      .text {
        font-size: 14px;
        line-height: 18px;
        display: block;
        color: var(--white);
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .text-box {
      width: 100%;
    }
    .title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;
      margin: 0 0 10px;
    }

    .detail-holder {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 400px;
      padding: 15px;
      border-left: 1px solid #cdcdcd;
      border-radius: 10px 0 0 10px;
      background: var(--white);
      transform: translateX(102%);
      transition: all 0.3s ease-in-out;
      z-index: 72;

      .detail-active & {
        transform: translateX(0);
      }

      @media screen and (min-width: 1600px) {
        width: 500px;
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin: 0 0 15px;

        .title {
          font-size: 18px;
          line-height: 22px;
          font-weight: 700;
          margin: 0;
        }

        .btn-close {
          width: 25px;
          height: 25px;
          border: 1px solid var(--text-color);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }
      }

      .text-area {
        width: 100%;
        height: calc(100vh - 70px);
        overflow: auto;
        padding-right: 5px;
      }
    }
  }
  .block-heading {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    color: var(--text-color-50);
  }

  .imgs-holder {
    max-width: 100%;
    overflow-x: auto;
    .img-wrap {
      width: 100%;
      height: 200px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        margin-bottom: 20px;
      }
    }
  }
`;

export const ReponseMenu = styled(Menu)`
  ul {
    width: 300px;
    padding: 10px;
    border-radius: 20px;
    border: 3px solid rgba(157, 157, 157, 0.4);
    box-shadow: 0 0 10px rgba(157, 157, 157, 0.6);
  }
`;
export const MenuBtn = styled(MenuButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 50px;
  padding: 10px 6px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  text-transform: capitalize;
  border-radius: 12px;
  border: 1px solid rgba(157, 157, 157, 0.6);
  background: #f1f1f1;

  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 12px;
    background: rgba(26, 42, 108, 0.1);
  }
`;
export const StyleItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  margin: 0 0 6px;
  border-radius: 10px;
  border: 1px solid transparent;

  &.active,
  &:hover {
    border-color: var(--text-color);
    background: rgba(3, 160, 141, 0.1);
  }

  &:last-child {
    margin: 0;
  }

  .wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .icon-box {
    width: 35px;
  }

  .pro {
    display: block;
    min-width: 50px;
    padding: 5px;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--text-color);
    text-align: center;
    border-radius: 10px;
    background: var(--primary);
  }
`;
